import { t } from 'state/intl/translations';

import type { CustomTextFn } from './types';

export const getQuestText: CustomTextFn = () => t('challenge');
export const getContinueQuestText: CustomTextFn = () => t('continueChallenge');
export const getQuestTermsText: CustomTextFn = () => t('questTerms', { quest: t('challenge') });

export const getLinkText: CustomTextFn = () => t('viewTerms');
export const getQuestStartedBadgeText: CustomTextFn = () => t('challengeStarted');

export const getQuestLoadErrorText: CustomTextFn = () =>
  t('questLoadError', { quest: t('challenge') });
export const getQuestCheckConnectionText: CustomTextFn = () => t('questCheckNetworkText');
